var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JsonObject, JsonProperty } from 'json2typescript';
export var EndpointHTTPMethod;
(function (EndpointHTTPMethod) {
    EndpointHTTPMethod["POST"] = "POST";
    EndpointHTTPMethod["GET"] = "GET";
    EndpointHTTPMethod["PATCH"] = "PATCH";
    EndpointHTTPMethod["PUT"] = "PUT";
    EndpointHTTPMethod["DELETE"] = "DELETE";
    EndpointHTTPMethod["ANY"] = "*";
})(EndpointHTTPMethod || (EndpointHTTPMethod = {}));
export var EndpointValidationMethod;
(function (EndpointValidationMethod) {
    EndpointValidationMethod["NoValidation"] = "NO_VALIDATION";
    EndpointValidationMethod["VerifyPayload"] = "VERIFY_PAYLOAD";
    EndpointValidationMethod["SecretAsQueryParam"] = "SECRET_AS_QUERY_PARAM";
})(EndpointValidationMethod || (EndpointValidationMethod = {}));
export var WebhookConversionStrategy;
(function (WebhookConversionStrategy) {
    WebhookConversionStrategy["DryRun"] = "dryRun";
    WebhookConversionStrategy["Overwrite"] = "overwrite";
    WebhookConversionStrategy["NoStrategy"] = "";
})(WebhookConversionStrategy || (WebhookConversionStrategy = {}));
var Endpoint = (function () {
    function Endpoint(partial) {
        this.id = undefined;
        this.route = '';
        this.functionName = '';
        this.functionId = '';
        this.httpMethod = EndpointHTTPMethod.ANY;
        this.validationMethod = EndpointValidationMethod.NoValidation;
        this.secretId = undefined;
        this.secretName = undefined;
        this.createUserOnAuth = false;
        this.fetchCustomUserData = false;
        this.respondResult = false;
        this.lastModified = undefined;
        this.disabled = false;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('_id', String, true),
        __metadata("design:type", String)
    ], Endpoint.prototype, "id", void 0);
    __decorate([
        JsonProperty('route'),
        __metadata("design:type", Object)
    ], Endpoint.prototype, "route", void 0);
    __decorate([
        JsonProperty('function_name'),
        __metadata("design:type", Object)
    ], Endpoint.prototype, "functionName", void 0);
    __decorate([
        JsonProperty('function_id'),
        __metadata("design:type", Object)
    ], Endpoint.prototype, "functionId", void 0);
    __decorate([
        JsonProperty('http_method'),
        __metadata("design:type", String)
    ], Endpoint.prototype, "httpMethod", void 0);
    __decorate([
        JsonProperty('validation_method', String),
        __metadata("design:type", String)
    ], Endpoint.prototype, "validationMethod", void 0);
    __decorate([
        JsonProperty('secret_id', String, true),
        __metadata("design:type", String)
    ], Endpoint.prototype, "secretId", void 0);
    __decorate([
        JsonProperty('secret_name', String, true),
        __metadata("design:type", String)
    ], Endpoint.prototype, "secretName", void 0);
    __decorate([
        JsonProperty('create_user_on_auth', Boolean, true),
        __metadata("design:type", Boolean)
    ], Endpoint.prototype, "createUserOnAuth", void 0);
    __decorate([
        JsonProperty('fetch_custom_user_data', Boolean, true),
        __metadata("design:type", Boolean)
    ], Endpoint.prototype, "fetchCustomUserData", void 0);
    __decorate([
        JsonProperty('respond_result', Boolean, true),
        __metadata("design:type", Boolean)
    ], Endpoint.prototype, "respondResult", void 0);
    __decorate([
        JsonProperty('last_modified', Number, true),
        __metadata("design:type", Number)
    ], Endpoint.prototype, "lastModified", void 0);
    __decorate([
        JsonProperty('disabled', Boolean),
        __metadata("design:type", Object)
    ], Endpoint.prototype, "disabled", void 0);
    Endpoint = __decorate([
        JsonObject('Endpoint'),
        __metadata("design:paramtypes", [Object])
    ], Endpoint);
    return Endpoint;
}());
export { Endpoint };
var PartialEndpoint = (function () {
    function PartialEndpoint() {
        this.id = '';
        this.route = '';
        this.functionName = '';
        this.functionId = '';
        this.httpMethod = EndpointHTTPMethod.ANY;
        this.lastModified = undefined;
    }
    __decorate([
        JsonProperty('_id'),
        __metadata("design:type", Object)
    ], PartialEndpoint.prototype, "id", void 0);
    __decorate([
        JsonProperty('route'),
        __metadata("design:type", Object)
    ], PartialEndpoint.prototype, "route", void 0);
    __decorate([
        JsonProperty('function_name'),
        __metadata("design:type", Object)
    ], PartialEndpoint.prototype, "functionName", void 0);
    __decorate([
        JsonProperty('function_id'),
        __metadata("design:type", Object)
    ], PartialEndpoint.prototype, "functionId", void 0);
    __decorate([
        JsonProperty('http_method'),
        __metadata("design:type", String)
    ], PartialEndpoint.prototype, "httpMethod", void 0);
    __decorate([
        JsonProperty('last_modified', Number, true),
        __metadata("design:type", Number)
    ], PartialEndpoint.prototype, "lastModified", void 0);
    PartialEndpoint = __decorate([
        JsonObject('PartialEndpoint')
    ], PartialEndpoint);
    return PartialEndpoint;
}());
export { PartialEndpoint };
var ConvertEndpointRequest = (function () {
    function ConvertEndpointRequest(partial) {
        this.strategy = WebhookConversionStrategy.NoStrategy;
        Object.assign(this, partial);
    }
    ConvertEndpointRequest = __decorate([
        JsonObject('ConvertEndpointRequest'),
        __metadata("design:paramtypes", [Object])
    ], ConvertEndpointRequest);
    return ConvertEndpointRequest;
}());
export { ConvertEndpointRequest };
//# sourceMappingURL=Endpoint.js.map